(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Sticky Header functionality
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header') || this;
      this.currentScrollTop = 0;
      this.threshold = 10;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.querySelector('details[open]') || this.contains(document.activeElement)) {
        this.reveal();
        return;
      }

      if (scrollTop <= 50) {
        this.reset();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop + this.threshold) {
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop - this.threshold) {
        requestAnimationFrame(() => this.reveal());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.classList.add('shopify-section-header-hidden');
      this.classList.remove('shopify-section-header-sticky');
      this.closeDisclosures();
    }

    reveal() {
      this.classList.add('shopify-section-header-sticky');
      this.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    closeDisclosures() {
      this.querySelectorAll('details[open]').forEach(details => {
        details.removeAttribute('open');
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Keep hamburger menu drawer aligned to the left edge of the viewport
  function updateMenuDrawerScreenOffset() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const offset = Math.max(0, headerDrawer.getBoundingClientRect().left);
    headerDrawer.style.setProperty('--menu-drawer-screen-offset', `${offset}px`);
  }

  document.addEventListener('DOMContentLoaded', updateMenuDrawerScreenOffset);
  window.addEventListener('resize', updateMenuDrawerScreenOffset, { passive: true });

  // Close hamburger/menu drawer when clicking or tapping outside it.
  document.addEventListener('pointerdown', function(event) {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const details = headerDrawer.querySelector('details');
    if (!details || !details.hasAttribute('open')) return;

    // Keep interactions inside the drawer and on its toggle working normally.
    if (headerDrawer.contains(event.target)) return;

    details.removeAttribute('open');

    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }

    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile');
  });


  // =========================================================
  // EXCLUDE EARLY-ACCESS TEMPLATE PRODUCTS FROM PREDICTIVE SEARCH
  // =========================================================
  // Shopify's predictive search response does not expose template_suffix
  // directly in the header markup. When search results are inserted, this
  // checks each product URL's JSON payload and removes products assigned
  // to the "early-access" product template before they can remain visible.
  (() => {
    const EARLY_ACCESS_TEMPLATE = 'early-access';
    const checkedUrls = new Map();

    async function isEarlyAccessProduct(url) {
      try {
        const parsed = new URL(url, window.location.origin);

        if (!parsed.pathname.includes('/products/')) return false;

        // Normalize product URL and query Shopify's product JSON endpoint.
        const productPath = parsed.pathname.replace(/\/$/, '');
        const jsonUrl = `${productPath}.json`;

        if (checkedUrls.has(jsonUrl)) {
          return checkedUrls.get(jsonUrl);
        }

        const request = fetch(jsonUrl, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(response => {
            if (!response.ok) return false;
            return response.json();
          })
          .then(data => {
            const product = data && data.product ? data.product : data;
            return product && product.template_suffix === EARLY_ACCESS_TEMPLATE;
          })
          .catch(() => false);

        checkedUrls.set(jsonUrl, request);
        return request;
      } catch (error) {
        return false;
      }
    }

    async function filterEarlyAccessSearchResults(root = document) {
      const predictiveRoot =
        root.matches?.('predictive-search, #predictive-search-results, .predictive-search')
          ? root
          : root.querySelector?.('predictive-search, #predictive-search-results, .predictive-search');

      if (!predictiveRoot) return;

      const links = Array.from(
        predictiveRoot.querySelectorAll('a[href*="/products/"]')
      );

      await Promise.all(
        links.map(async link => {
          if (link.dataset.earlyAccessChecked === 'true') return;
          link.dataset.earlyAccessChecked = 'true';

          if (await isEarlyAccessProduct(link.href)) {
            const item =
              link.closest('li, .predictive-search__list-item, .predictive-search__item') ||
              link;

            item.remove();
          }
        })
      );

      // Remove empty headings/groups left behind after filtering.
      predictiveRoot
        .querySelectorAll('.predictive-search__results-groups-wrapper > div, .predictive-search__result-group')
        .forEach(group => {
          if (!group.querySelector('a[href*="/products/"]')) {
            const productList = group.querySelector('ul');
            if (productList && productList.children.length === 0) {
              group.remove();
            }
          }
        });
    }

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (
            node.matches?.('predictive-search, #predictive-search-results, .predictive-search') ||
            node.querySelector?.('predictive-search, #predictive-search-results, .predictive-search')
          ) {
            filterEarlyAccessSearchResults(node);
          }
        }
      }

      // Also catch result replacement inside an existing predictive-search element.
      const existing = document.querySelector(
        'predictive-search, #predictive-search-results, .predictive-search'
      );
      if (existing) filterEarlyAccessSearchResults(existing);
    });

    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      filterEarlyAccessSearchResults(document);
    });
  })();


  // Mobile Drawer Injector for Secondary Links
  document.addEventListener('DOMContentLoaded', function() {
    const drawerNav = document.querySelector('.menu-drawer__navigation');
    const desktopSecondaryMenu = document.getElementById('DesktopSecondaryMenu');
    
    if (drawerNav && desktopSecondaryMenu) {
      const mobileMenuContainer = document.createElement('nav');
      mobileMenuContainer.classList.add('mobile-secondary-menu-container');
      mobileMenuContainer.setAttribute('aria-label', 'Secondary navigation');
      
      const clonedMenu = desktopSecondaryMenu.cloneNode(true);
      clonedMenu.id = 'MobileSecondaryMenu';
      clonedMenu.classList.remove('header__secondary-menu');
      clonedMenu.classList.add('mobile-secondary-menu');
      
      mobileMenuContainer.appendChild(clonedMenu);
      drawerNav.appendChild(mobileMenuContainer);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
